import * as types from '../../actions/types';

const initialState = {
  featuredPosts: [],
  isLoading: false,
  error: null,
};

const blogFeaturedPosts = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_BLOG_POSTS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case types.GET_BLOG_POSTS_SUCCESS:
      // Filter featured posts
      const featured = action.payload?.results 
        ? action.payload.results.filter(post => post.is_featured)
        : [];
      return {
        ...state,
        featuredPosts: featured,
        isLoading: false,
        error: null,
      };
    case types.GET_BLOG_POSTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default blogFeaturedPosts;